import { Component, OnInit, ChangeDetectionStrategy, QueryList, Input, AfterViewInit, ContentChildren, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ViewTourSlideComponent } from '../view-tour-slide/view-tour-slide.component';
import { merge, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-view-tour-page',
  templateUrl: './view-tour-page.component.html',
  styleUrls: ['./view-tour-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewTourPageComponent implements OnInit, AfterViewInit, OnDestroy {

  @ContentChildren(ViewTourSlideComponent) slides: QueryList<ViewTourSlideComponent>;

  @Input()
  set shown(value: boolean) {
    this._shown = value;
    this.setSelectedSlide(0);
  }
  get shown(): boolean {
    return this._shown;
  }

  private selectedSlideIndex = 0;
  private _shown = false;
  private ngUnsubscribe = new Subject();

  constructor(private changeRef: ChangeDetectorRef) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.initListeners();

    // update view
    setTimeout(() => {
      this.setSlideShown(this.selectedSlideIndex);
    });    
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  goToPrevSlide() {
    this.setSelectedSlide(this.selectedSlideIndex - 1);
  }

  goToNextSlide() {
    this.setSelectedSlide(this.selectedSlideIndex + 1);
  }

  setSelectedSlide(index: number) {
    this.selectedSlideIndex = index;
    // normalize range
    if (this.slides) {
      const slideCount = this.slides.length;
      const targetIndex = Math.max(0,
        Math.min(slideCount - 1, index)
      );
      this.selectedSlideIndex = targetIndex;
    }
    // update view
    this.setSlideShown(this.selectedSlideIndex);
  }

  private initListeners() {
    // navigate slides as they trigger completion
    merge(
      ...this.slides.map((slide) => slide.triggerComplete.asObservable())
    )
      .pipe(
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(() => {
        this.goToNextSlide();
      });
  }

  private setSlideShown(shownIndex: number) {
    if (this.slides) {
      this.slides.forEach((slide, slideIndex) => {
        slide.shown = slideIndex === shownIndex;
      });
    }
    this.changeRef.markForCheck();
  }

}
